// externals
import { useSelector } from 'react-redux';

// libraries
import * as appSelectors from '@makemydeal/dr-dash-store/selectors/appSelectors';
import * as offerInfoSelectors from '@makemydeal/dr-dash-store/selectors/offerInfoSelectors';

// components
import { PendingReviewRetentionScreen } from './PendingReviewRetentionScreen';

const PendingReviewRetentionHost = () => {
    const pendingReview = useSelector(offerInfoSelectors.getPendingReview);
    const isBootstrapComplete = useSelector(appSelectors.isLazyInitCompleteForSmartInit);
    // `isResolving` is never cleared, so without this the screen reopens on any remount after deciding.
    const resolution = useSelector(offerInfoSelectors.getPendingReviewResolution);

    const wantsScreen =
        pendingReview !== undefined &&
        pendingReview.isResolving &&
        pendingReview.resolutionPath === 'itemRetention' &&
        resolution === undefined;

    if (!wantsScreen || !isBootstrapComplete) {
        return null;
    }

    return <PendingReviewRetentionScreen />;
};

export default PendingReviewRetentionHost;
